export enum ListTypeEnum {
  ATIVOS = 'ativos',
  APROVANDO = 'aprovando',
  DESTAQUES = 'destaques',
  NEGOCIANDO = 'negociando',
  INATIVOS = 'inativos',
  ARQUIVADOS = 'arquivados',
  VENDIDOS = 'vendidos',
  ALUGADOS = 'alugados'
}
